import Component from '@glimmer/component'
import { service } from '@ember/service'
import type ReportingService from 'district-ui-client/services/reporting'
import { PeriodDatePicker } from 'district-ui-client/components/dates/period-date-picker'
import { formatDate } from 'district-ui-client/services/reporting'
import { Pill } from 'district-ui-client/components/pills'

interface Signature {
  Element: HTMLElement
  Args: {
    onDateChange: ({ start, end }: { start: Date; end: Date }) => void
    disabled?: boolean
  }
}

export default class ReportingPeriodSelect extends Component<Signature> {
  @service reporting!: ReportingService

  <template>
    <PeriodDatePicker
      data-test-period-select
      @period={{this.reporting.period}}
      @onPeriodSelected={{@onDateChange}}
      @isDisabled={{@disabled}}
      ...attributes
    />
    <Pill class="mt-1 w-fit" @disabled={{@disabled}}>
      {{formatDate this.reporting.period.start}}
      -
      {{formatDate this.reporting.period.end}}
    </Pill>
  </template>
}
